import { FC, PropsWithChildren } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { PageSizer } from './PageSizer';
import { ErrorCard } from '../error/ErrorCard';

export const PageError: FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <PageSizer className="py-5">
      <ErrorCard error={error} onClear={resetErrorBoundary} goHome />
    </PageSizer>
  );
};

export const PageErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  return <ErrorBoundary FallbackComponent={PageError}>{children}</ErrorBoundary>;
};
